import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../state/auth';
import { fetchMe } from './photozen';

export function AuthGuard({
  children,
  adminOnly = false,
}: {
  children: React.ReactNode;
  adminOnly?: boolean;
}) {
  const { token, user, setAuth, logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (token && !user) {
      fetchMe(token).then((u) => (u ? setAuth(token, u) : logout()));
    }
  }, [token, user, setAuth, logout]);

  if (!token) {
    const next = location.pathname + location.search;
    const loginPath = adminOnly ? '/admin/login' : '/login';
    const dest = next && next !== '/' ? `${loginPath}?next=${encodeURIComponent(next)}` : loginPath;
    return <Navigate to={dest} replace />;
  }
  if (!user) return <div className="flex items-center justify-center h-full text-white">加载中…</div>;
  if (adminOnly && !user.is_admin) return <Navigate to="/admin/login" replace />;
  return <>{children}</>;
}
